//libs
import React, { memo } from 'react';
import { useLocation } from 'react-router-dom';

//global components
import RouteChunkRenderer from 'shared/components/RouteChunkRenderer';
import ChunkFallback from 'shared/components/ChunkFallback';

//components
import Desktop from 'shared/layouts/ImageSearch/Desktop';
import Mobile from 'shared/layouts/ImageSearch/Mobile';
import BuiltInDesktop from 'shared/layouts/ImageSearch/BuiltInDesktop';

function ImageSearch() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const source = searchParams.get('source');
  const renderBuiltIn = source === 'builtIn';
  return (
    <RouteChunkRenderer
      mobileComponent={<Mobile fallback={<ChunkFallback />} />}
      desktopComponent={
        renderBuiltIn ? (
          <BuiltInDesktop fallback={<ChunkFallback />} />
        ) : (
          <Desktop fallback={<ChunkFallback />} />
        )
      }
    />
  );
}

export default memo(ImageSearch);
